'use client';
import React from 'react';

import { useTranslations } from 'next-intl';

import { TriviaStats } from './trivia-stats';
import { PlayTriviaTrigger } from './play-trivia-trigger';

export const TriviaGameHome = () => {
  const t = useTranslations();

  return (
    <div className="w-full">
      <div className="text-inlineTextColor6 mb-4 flex items-center">
        <h5 className="text-base font-medium">
          {t('your')} {t('scores')}
        </h5>
        <p className="text-text700 mb-0 ml-[5px] text-sm lowercase">
          ({t('last')} {t('30_days')})
        </p>
      </div>
      <TriviaStats />
      <PlayTriviaTrigger />
    </div>
  );
};
